import(/* webpackMode: "eager" */ "/app/packages/web-next/src/app/global-error.tsx");
